const shorten = (str, maxLen, separator = ' ', ommission = '...') => {
  if (str.length <= maxLen) return str;
  return str.substr(0, str.lastIndexOf(separator, maxLen)) + ommission;
};

export default shorten;
